module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Purchase Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "billNo",
      "disabled": ""
    },
    model: {
      value: (_vm.billNo),
      callback: function($$v) {
        _vm.billNo = $$v
      },
      expression: "billNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "refno"
    }
  }, [_vm._v("Ref. No.")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "refno"
    },
    model: {
      value: (_vm.refNo),
      callback: function($$v) {
        _vm.refNo = $$v
      },
      expression: "refNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purType"
    }
  }, [_vm._v("Pur Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxType),
      expression: "taxType"
    }],
    staticClass: "form-control ",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taxType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.taxTypeList), function(tax, ind) {
    return _c('option', {
      key: ind
    }, [_vm._v(_vm._s(tax.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "loadFrom"
    }
  }, [_vm._v("Load From")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "order",
      "value": "order"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "order")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "order"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Order")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "challan",
      "value": "challan"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "challan")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "challan"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Challan")])]), _vm._v(" "), (_vm.loadFromOrder && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.loadFromOrder && !this.editing) ? _c('label', {
    attrs: {
      "for": "OrderList"
    }
  }, [_vm._v(" Order List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.orderIdList,
      "optionLabel": "orderNo",
      "filter": true,
      "placeholder": "Select Item"
    },
    on: {
      "change": function($event) {
        return _vm.loadPurchaseDataWithOrderId(_vm.orderId.orderNo)
      }
    },
    model: {
      value: (_vm.orderId),
      callback: function($$v) {
        _vm.orderId = $$v
      },
      expression: "orderId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loadFromChallan && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.loadFromChallan && !this.editing) ? _c('label', {
    attrs: {
      "for": "ChallanList"
    }
  }, [_vm._v(" Challan List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.challanIdList,
      "optionLabel": "challanNo",
      "filter": true,
      "placeholder": "Select Item"
    },
    on: {
      "change": function($event) {
        return _vm.loadPurchaseDataWithChallanId(_vm.challanId.challanNo)
      }
    },
    model: {
      value: (_vm.challanId),
      callback: function($$v) {
        _vm.challanId = $$v
      },
      expression: "challanId"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Vendor")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.supplierAndCustomerList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Account",
      "showClear": true
    },
    model: {
      value: (_vm.accountMaster),
      callback: function($$v) {
        _vm.accountMaster = $$v
      },
      expression: "accountMaster"
    }
  })], 1), _vm._v(" "), _c('supplierDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Supplier'),
      expression: "'Add Supplier'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5"
  }), _vm._v(" "), (_vm.ifCash) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Supplier")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.customerAccountList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select supplier",
      "showClear": true
    },
    model: {
      value: (_vm.cashTransactionMaster),
      callback: function($$v) {
        _vm.cashTransactionMaster = $$v
      },
      expression: "cashTransactionMaster"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ifCash) ? _c('supplierDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Supplier'),
      expression: "'Add Supplier'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    on: {
      "set_supplier_master": _vm.set_supplier_master
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select store",
      "showClear": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }) : _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  })], 1), _vm._v(" "), _c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    staticStyle: {
      "margin-right": "-10em"
    },
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), (!_vm.ifNotCash) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [(_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Tax No:")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.accountMaster.panNo))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Cur. Bal:")]), _vm._v(" "), (_vm.accountMaster.closingBalance > 0) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.accountMaster.closingBalance).toFixed(2) + 'Cr') + "\n                  ")]) : _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr') + "\n                  ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    staticStyle: {
      "margin-right": "-10em"
    },
    on: {
      "set_data_item": _vm.set_data_item
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "qty",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "unit",
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "rate",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "total",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTOList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editDTO) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOreset
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.findRate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.setRateFromItem))]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "avl"
    }
  }, [_vm._v("Cur. Stock:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.items.closingStock))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.itemMaster.unitName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s((item.rate * item.quantity).toFixed(4)) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "16em"
    }
  }, [_vm._v(_vm._s(_vm.totalQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "38em"
    }
  }, [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narration),
      expression: "narration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('table', {
    staticStyle: {
      "border": "1px solid #c8c8c8"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Subtotal ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Discount ")]), _vm._v(" "), (_vm.chooseDiscountAmt) ? _c('Button', {
    attrs: {
      "label": "Rs"
    },
    on: {
      "click": _vm.chooseDisountAmt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountPer) ? _c('Button', {
    attrs: {
      "label": "%"
    },
    on: {
      "click": _vm.chooseDisPercent
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 0em 0px"
    }
  }, [(_vm.chooseDiscountPer) ? _c('InputText', {
    attrs: {
      "onfocus": "if (this.value === '0')\n                      this.value = ''",
      "placeholder": "discountPer"
    },
    model: {
      value: (_vm.discountPer),
      callback: function($$v) {
        _vm.discountPer = $$v
      },
      expression: "discountPer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountAmt) ? _c('InputText', {
    attrs: {
      "onfocus": "if (this.value === '0')\n                                  this.value = ''",
      "placeholder": "discountamt"
    },
    model: {
      value: (_vm.discountAmt),
      callback: function($$v) {
        _vm.discountAmt = $$v
      },
      expression: "discountAmt"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Discounted Amt: ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.discountAmt))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Excise Duty ")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "onfocus": "if (this.value === '0')\n                                  this.value = ''"
    },
    model: {
      value: (_vm.exciseDuty),
      callback: function($$v) {
        _vm.exciseDuty = $$v
      },
      expression: "exciseDuty"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.exciseDuty))])], 1), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Taxable ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.taxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Non-taxable ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.nonTaxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Tax ")]), _vm._v(" "), _c('th', [_vm._v("13%")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.tax.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v("Total ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #c8c8c8",
      "padding": "0px 5em 7px 5em"
    }
  }, [_vm._v(_vm._s(_vm.totalBillAmount.toFixed(4)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('form', [_c('label', [_vm._v("Extra Expenses:")]), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '75vw',
      height: '20vw'
    }),
    attrs: {
      "header": "Extra Expenses",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Extra Expenses Name")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.extraExpensesList,
      "optionLabel": "expensesName",
      "filter": true,
      "placeholder": "Select Expenses",
      "id": "extraExpense",
      "showClear": true
    },
    model: {
      value: (_vm.extraExpenses),
      callback: function($$v) {
        _vm.extraExpenses = $$v
      },
      expression: "extraExpenses"
    }
  })], 1), _vm._v(" "), _c('extraExpensesDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Extra Expenses'),
      expression: "'Add Extra Expenses'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    staticStyle: {
      "margin-right": "-10em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply Vat")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('InputSwitch', {
    model: {
      value: (_vm.applyVat),
      callback: function($$v) {
        _vm.applyVat = $$v
      },
      expression: "applyVat"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpensesAmt"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "extraExpensesAmt"
    },
    model: {
      value: (_vm.extraExpenseAmt),
      callback: function($$v) {
        _vm.extraExpenseAmt = $$v
      },
      expression: "extraExpenseAmt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply On Bill")])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('InputSwitch', {
    model: {
      value: (_vm.applyExpensesOnBill),
      callback: function($$v) {
        _vm.applyExpensesOnBill = $$v
      },
      expression: "applyExpensesOnBill"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": !_vm.editExtraExpenses ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExtraExpensesToList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editExtraExpenses) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelExtraExpenses.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "margin-top": "2em",
      "border": "1px solid #c8c8c8"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Expenses Name")]), _vm._v(" "), _c('th', [_vm._v("Apply Vat")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.inventoryExtraExpensesList), function(expense, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpense.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.applyVat ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpenseAmt))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editExtraExpensesDto(expense, index)
        }
      }
    }), _vm._v(" "), (_vm.editExtraExpenses) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    }) : _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    })], 1)])])
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": _vm.purchaseInvoice === undefined ? 'Save' : 'Update'
    },
    on: {
      "click": _vm.addPurchaseInvoice
    }
  })], 1), _vm._v(" "), (_vm.purchaseInvoice == undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": _vm.reset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.purchaseInvoice != undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "disabled": "",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "itm"
    }
  }, [_vm._v("Item"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a2739fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/fixedAssetsPurchase/fixedAssetsPurchaseInvoice.vue
// module id = 2026
// module chunks = 0